import debounce from "lodash/debounce";
import { Button } from "plos/src/components/buttons/Button";
import { ChevronLeft, ChevronRight } from "../../icons/Chevrons";
import { buttonWrapperStyles } from "./fdrTableNav.css";
import { FDRTableNavProps } from "./types";
import { useTranslation } from "react-i18next";

const FDRTableNav = ({
  showPrevBtn,
  showNextBtn,
  onHandlePrevClick,
  onHandleNextClick,
}: FDRTableNavProps) => {
  const { t } = useTranslation("fixturesAndFDR");
  return (
    <div className={buttonWrapperStyles}>
      <Button
        appearance="outlined"
        size="small"
        fullWidth={true}
        isDisabled={!showPrevBtn}
        onPress={debounce(onHandlePrevClick, 250)}
        aria-label={
          t("fdrTableNav.prevGameweek.label", "Previous Gameweek") as string
        }
        data-testid="prev-btn"
      >
        <ChevronLeft height={12} width={12} />
        {t("fdrTableNav.prevGameweek.btnText", "Previous GW")}
      </Button>

      <Button
        appearance="outlined"
        size="small"
        fullWidth={true}
        isDisabled={!showNextBtn}
        onPress={debounce(onHandleNextClick, 250)}
        aria-label={
          t("fdrTableNav.nextGameweek.label", "Next Gameweek") as string
        }
        data-testid="next-btn"
      >
        {t("fdrTableNav.nextGameweek.btnText", "Next GW")}
        <ChevronRight height={12} width={12} />
      </Button>
    </div>
  );
};
export default FDRTableNav;
